import { Capacitor } from '@capacitor/core';

/** True inside the Capacitor Android shell, false in an ordinary browser. */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}
